import React from 'react';
import { css } from '@emotion/react';
import { i18n_all_episodes } from '@yi/i18n/phrases/i18n_all_episodes';

import type { Series } from '~/src/common/lean-back';
import { useLocale } from '~/src/components/LocaleProvider';
import { breakpoints } from '~/src/styles';
import { typography } from '~/src/styles/design-system';
import { resetStyles } from '~/src/styles/reset-styles-mixins';

import { SeasonEpisodes } from './SeasonEpisodes';
import { SeasonSelector } from './SeasonSelector';
import { SeasonsProvider } from './SeasonsProvider';

type Props = { series: Series };

const styles = {
  title: css(resetStyles.heading, typography.mobileHeading4, {
    color: 'var(--Dark-Text)',
    marginBottom: '16px',
    textTransform: 'capitalize',
    [breakpoints.minTablet]: {
      marginBottom: '24px',
    },
  }),
};

export const Seasons: React.FC<Props> = ({ series }) => {
  const { locale } = useLocale();
  return (
    <div>
      <SeasonsProvider series={series}>
        <h4 css={styles.title}>{i18n_all_episodes(locale)}</h4>
        <SeasonSelector />
        <SeasonEpisodes />
      </SeasonsProvider>
    </div>
  );
};
